import { DataMappingEditorModal } from "../../system/data-mapping/DataMappingEditorModal";
import { Button, Card, Icon, Stack, Title, useToast } from "@introist/react-foundation/v2";
import { DataSourceIcon } from "../../datasources/components/DataSourceIcon";
import { useDatasetSyncActions, useDatasetSyncConfig } from "./useDatasetSyncConfig";
import { useState } from "react";
import { api } from "../../../services/rpc/RpcProvider";
import { useDatasetFields } from "../hooks/useDatasetFields";

export const SyncMapping = ({ datasetId }: { datasetId: string }) => {
  const toast = useToast();

  const { config } = useDatasetSyncConfig(datasetId);
  const { fields } = useDatasetFields({ datasetId, refOptions: true });

  const { data: sourceFields } = api.datasets.sync.config.sourceFields.useQuery(
    { id: config?.id ?? "" },
    { enabled: !!config }
  );

  const { data: ds } = api.employees.dataSources.find.useQuery(
    { dataSourceId: config?.dataSourceId ?? "" },
    { enabled: !!config }
  );

  const { update } = useDatasetSyncActions();

  const [mappingEditOpen, setMappingEditOpen] = useState(false);

  if (!config || !ds) return null;

  return (
    <>
      <Card>
        <Stack alignItems="center" justifyContent="center">
          <DataSourceIcon dataSource={ds.sourceType} />
          <Icon name="arrowRight" />
          <Button variant="blended" onClick={() => setMappingEditOpen(true)}>
            {config.mapping.length} fields synced
          </Button>
          <Icon name="arrowRight" />
          <DataSourceIcon dataSource="introist" />
        </Stack>
      </Card>
      <DataMappingEditorModal
        open={mappingEditOpen}
        initialValue={config.mapping}
        onClose={() => setMappingEditOpen(false)}
        onSave={mapping =>
          update(config.id, { mapping }).then(() => {
            setMappingEditOpen(false);
            toast.success("Mapping updated");
          })
        }
        sourceFields={(sourceFields ?? []).map(f => ({ key: f.path, title: f.title }))}
        targetFields={(fields ?? []).map(f => ({
          key: f.key,
          title: f.title,
          additionalDescription: f.refOptions ? "by" : undefined,
          additionalOptions: f.refOptions
            ?.filter(f => f.type !== "reference")
            .map(opt => ({ key: opt.id, title: opt.title }))
        }))}
        sourceHeader={
          <Stack>
            <DataSourceIcon dataSource={ds.sourceType} size="small" />
            <Title variant="bold">{ds.name}</Title>
          </Stack>
        }
        targetHeader={
          <Stack>
            <DataSourceIcon dataSource="introist" size="small" />
            <Title variant="bold">Introist</Title>
          </Stack>
        }
        maxWidth={900}
      />
    </>
  );
};
